import { Outlet } from "react-router";
import AppHeader from "./AppHeader";
import "./AppLayout.scss";

const AppLayout: React.FC = () => {
  return (
    <div className="app-layout">
      {/* Header */}
      <AppHeader />

      {/* Main Content */}
      <main className="app-main">
        <Outlet />
      </main>
    </div>
  );
};

export default AppLayout;
